import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'csi-terms-of-use',
  templateUrl: './terms-of-use.component.html',
  styleUrls: ['./terms-of-use.component.css']
})
export class TermsOfUseComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
